import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AncDataService } from 'src/app/services/ANC/anc-data.service';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ModalAncSuntimesYearlyComponent } from 'src/app/components/ui/modal-anc-suntimes-yearly/modal-anc-suntimes-yearly.component';
import { AstCalendarService } from 'src/app/services/sunTimes/suntimes.service';
import { SuntimesService } from 'src/app/services/sunTimes/sunTimesLegacy.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import Chart from 'chart.js/auto';
import tzLookup from 'tz-lookup';
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { WebsocketService } from 'src/app/services/websocket/websocket.service';
import { getRelayOutputCount } from 'src/app/services/devices/device-type.util';
import data from '../anc2/data';

@Component({
    selector: 'app-a2',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './a2.component.html'
})
export class A2Component implements OnInit, OnDestroy {

  private connectTimer?: ReturnType<typeof setTimeout>;

  // Mostrar carril de periodos festivos (entre carril de noche y globos de orto/ocaso)
  private readonly showHolidayPeriodLane = true;

  @Input() serial: string = '';
  @ViewChild('programTodayOut1') editCanvasOut1!: ElementRef<HTMLCanvasElement>;
  @ViewChild('programTodayOut2') editCanvasOut2!: ElementRef<HTMLCanvasElement>;
  @ViewChild('overlayContainer') overlayContainer!: ElementRef<HTMLElement>;
  @ViewChild('sunLinesOverlay') sunLinesOverlay!: ElementRef<HTMLCanvasElement>;

  loanding = true
  ancDeviceInfo: any;
  deviceInfo: any;
  coordenadas: any;
  ubicacion: any = { country: '', city: '' };
  sunTimesData: any[] = [];
  scheduleInfo: any;
  channelInfo: any;
  orgianalChannelInfo: any;
  holidayInfo: any = { enable: 0, periods: [] };
  calendarCfg: any;
  calendarStat: any;
  loadState = {
    c1: false,
    c2: false
  }

  clockTime: any
  warning = false
  loadingClockSync = false;
  lastConnection: string = '';

  programsInfo: any[] = [];
  programDataFormated: any[] = [];
  todayPeriod: any = {};
  timeZone: string = '';
  seasonsInfo: any = { enable: 0, winter: [], summer: [] };


  daysOfWeek = [
    { index: 0, label: 'Lunes', value: 64, short: 'L' },
    { index: 1, label: 'Martes', value: 32, short: 'M' },
    { index: 2, label: 'Miércoles', value: 16, short: 'X' },
    { index: 3, label: 'Jueves', value: 8, short: 'J' },
    { index: 4, label: 'Viernes', value: 4, short: 'V' },
    { index: 5, label: 'Sábado', value: 2, short: 'S' },
    { index: 6, label: 'Domingo', value: 1, short: 'D' }
  ];

  private readonly minutesPerDay = 1440;
  private readonly weekMinutes = this.minutesPerDay * 7;
  private readonly windowBackMinutes = 6 * 60;
  private readonly windowForwardMinutes = 24 * 60;
  private readonly nowSnapMinutes = 10;
  private readonly clockDriftWarningThresholdMinutes = 3; // Umbral de aviso de sincrozinación


  private chartOut1: Chart | null = null;
  private chartOut2: Chart | null = null;

  chartDataOut1: number[] = [];
  chartDataOut2: number[] = [];
  private nowLineTimerId: number | null = null;
  private deviceClockBaseDate: Date | null = null;
  private deviceClockCapturedAtMs: number | null = null;
  private deviceClockDriftMinutes: number | null = null;

  constructor(private _modal: ModalService, private astCalendarService: AstCalendarService, private _device: DeviceService,
    private _ancDataService: AncDataService, private suntimesService: SuntimesService, private _util: UtilsService,
    private _ws: WebsocketService,
    private translate: TranslateService,
    ) { }

  private t(key: string, params?: Record<string, unknown>): string {
    return this.translate.instant(key, params);
  }

  get outputCount(): number {
    return getRelayOutputCount(this.serial);
  }

  get clockDriftWarningTitle(): string {
    if (this.deviceClockDriftMinutes == null) {
      return this.t('dlClockNotSynced');
    }
    const minutes = Math.abs(this.deviceClockDriftMinutes);
    const direction = this.t(this.deviceClockDriftMinutes > 0 ? 'dlClockDriftAhead' : 'dlClockDriftBehind');
    return this.t('dlClockDrift', { minutes, direction });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    // Chart.js se redimensiona solo; el overlay hay que repintarlo.
    window.setTimeout(() => this.renderSunLinesOverlay(), 50);
  }

  ngOnDestroy(): void {
    // Sin esto el timer de arranque conecta el websocket tras destruir la pantalla y le roba el socket a la siguiente.
    clearTimeout(this.connectTimer);
    if (this.nowLineTimerId != null) {
      window.clearInterval(this.nowLineTimerId);
      this.nowLineTimerId = null;
    }

    this._ws.close();
    this.chartOut1?.destroy();
    this.chartOut1 = null;
    this.chartOut2?.destroy();
    this.chartOut2 = null;
  }


  ngOnInit(): void {

    this.connectTimer = setTimeout(() => {
      this.loadData();
      this.connectWebsocket();
      this.loanding = false;
    }, 1000);
  }

  connectWebsocket() {
    this._ws.connect(this.serial).subscribe(message => {
      console.log('Websocket message received:', message);
      this.channelInfo.stat.c1stat = message.data.stat.c1stat;
      this.channelInfo.stat.c2stat = message.data.stat.c2stat;
      this.lastConnection = new Date().toISOString();
    });
  }

  loadData(){

    this._device.getModuleInfo(this.serial, 'seasons').subscribe(data => {
      this.lastConnection = new Date().toISOString();
      console.log('seasons raw ', data);
      this.seasonsInfo = this._ancDataService.formatSeasonData(data.cfg);
      console.log('Seasons Info:', this.seasonsInfo);
      this.refreshSunTimesData();
    });


    this._device.getModuleInfo(this.serial, 'device').subscribe(deviceInfo => {
      this.ancDeviceInfo = deviceInfo.cfg;
      console.log('ANC DEVICE', this.ancDeviceInfo);

      this._device.getDeviceInfo(this.serial).subscribe(deviceInfo => {
        this.lastConnection = new Date().toISOString();
        this.deviceInfo = deviceInfo;
        const version = deviceInfo.hardware_version.split('.').pop() ?? '';
        this.coordenadas = this._ancDataService.getLocation(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);
        this.ubicacion = this._ancDataService.getCountryCityNames(version, this.ancDeviceInfo.country, this.ancDeviceInfo.city);

        // Calcular offset UTC real según la zona horaria del punto (evita heurística por meses)
        const now = new Date();
        const timeZone = tzLookup(this.coordenadas?.latitude ?? 0, this.coordenadas?.longitude ?? 0);
        this.timeZone = timeZone;

        this.refreshSunTimesData();
        console.log('TimeZone ', this.timeZone);
      });
    });

    this._device.getModuleInfo(this.serial, 'schedule').subscribe(data => {
      console.log('Schedule Info:', data.cfg);
      this.scheduleInfo = data.cfg;
      this.programDataFormated = this._ancDataService.formatProgramData(data.cfg);
      console.log('programas formateados ', this.programDataFormated);

    });

    this._device.getModuleInfo(this.serial, 'channel').subscribe(channelInfo => {
      console.log('Channel Info:', channelInfo);
      this.channelInfo = channelInfo;
      this.orgianalChannelInfo = JSON.parse(JSON.stringify(channelInfo));
      this.lastConnection = new Date().toISOString();
    });

    this._device.getModuleInfo(this.serial, 'holiday').subscribe(holidayInfo => {
      this.lastConnection = new Date().toISOString();
      this.holidayInfo = this._ancDataService.formatHolidayData(holidayInfo.cfg);
      if (this.holidayInfo.periods[0].enable || this.holidayInfo.periods[1].enable || this.holidayInfo.periods[2].enable || this.holidayInfo.periods[3].enable) {
        this.holidayInfo.enable = true
      } else {
        this.holidayInfo.enable = false;

      }
      console.log('holiday enable? ', this.holidayInfo.enable);
      console.log('Holiday Info ', this.holidayInfo);
      this.todayPeriod = this._ancDataService.isTodayInAnyPeriod(this.holidayInfo?.periods);
      console.log('Today is periodo ', this.todayPeriod);

      // Redibujar para que el indicador del periodo se vea inmediatamente.
      this.chartOut1?.update('none');
      this.chartOut2?.update('none');
    });



    setTimeout(() => {
      this.rebuildBothCharts();
    }, 500);

  }

  private getTimeZoneOffsetMinutes(date: Date, timeZone: string): number | null {
    if (!(date instanceof Date) || !Number.isFinite(date.getTime())) return null;
    if (!timeZone) return null;

    try {
      const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      const parts = dtf.formatToParts(date);
      const values: Record<string, string> = {};
      for (const p of parts) {
        if (p.type !== 'literal') values[p.type] = p.value;
      }

      const year = Number(values.year);
      const month = Number(values.month);
      const day = Number(values.day);
      const hour = Number(values.hour);
      const minute = Number(values.minute);
      const second = Number(values.second);
      if ([year, month, day, hour, minute, second].some(n => !Number.isFinite(n))) return null;

      const asUTC = Date.UTC(year, month - 1, day, hour, minute, second);
      return Math.round((asUTC - date.getTime()) / 60000);
    } catch {
      return null;
    }
  }

  private refreshSunTimesData(): void {
    if (!this.coordenadas) {
      return;
    }

    const startForSunTimes = new Date();
    startForSunTimes.setDate(startForSunTimes.getDate() - 1);

    this.sunTimesData = this.suntimesService.calculateSuntimesLegacyForWeekWithGmtResolver(
      startForSunTimes,
      (date) => this._ancDataService.getGmtMinutesForDate(date, this.coordenadas, this.seasonsInfo),
      this.coordenadas?.latitude ?? 0,
      this.coordenadas?.longitude ?? 0
    );

    this.addCorrectionToSunTimes();
  }

  addCorrectionToSunTimes() {
    this._device.getModuleInfo(this.serial, "calendar", "stat" ,{ localdata: true }).subscribe(data => {
      this.calendarStat = data.calendar;
      console.log('calendar stat ', this.calendarStat);
      this._device.getModuleInfo(this.serial, "calendar", "cfg").subscribe(data => {
        this.calendarCfg = data.cfg;
        if (this.calendarCfg.corrSunrise !== undefined && this.calendarCfg.corrSunset !== undefined) {
          const corrSunriseMinutes = this.calendarCfg.corrSunrise;
          const corrSunsetMinutes = this.calendarCfg.corrSunset;
          console.log('Correction object:', { corrSunriseMinutes, corrSunsetMinutes });
          this.sunTimesData = this.sunTimesData.map(day => {
            return {
              ...day,
              sunriseMin: day.sunriseMin + corrSunriseMinutes,
              sunriseStr: this._util.getDateFromMinutes(day.sunriseMin + corrSunriseMinutes),
              sunsetMin: day.sunsetMin + corrSunsetMinutes,
              sunsetStr: this._util.getDateFromMinutes(day.sunsetMin + corrSunsetMinutes)
            };
          });

        // Si el gráfico ya está creado, recalcular la semana con los nuevos ortos/ocasos.
        this.refreshExistingCharts();
        }
      });
      // this.lastConnection = this.calendarStat?.timestamp
      this.lastConnection = new Date().toISOString();
      this.clockTime = this._ancDataService.formatCalendarStatus(this.calendarStat);
      console.log('clockTime  ', this.clockTime);

      this.syncDeviceClockReference(this.clockTime);
      this.validateDeviceClockAgainstTimezone(this.clockTime);
      const now = new Date();
      console.log('ahora ',now);
      console.log('clockTime  ', this.clockTime);
      console.log('calendar status ', this.calendarStat);
      console.log('deviceClockDriftMinutes ', this.deviceClockDriftMinutes);
      console.log('clock drift warning? ', this.warning);
      console.log('Calendar Info for corrections:', this.calendarCfg);

    });
  }

  syncClock() {
    this.loadingClockSync = true;
    const nowParts = this.getNowPartsForTimeZone(this.timeZone);
    if (!nowParts) {
      this.loadingClockSync = false;
      return;
    }

    console.log('Partes del ahora ', nowParts);
    const date = new Date(nowParts.year, nowParts.month - 1, nowParts.day);
    let weekday = 0;
    if (date.getDay() === 0) weekday = 1 // Domingo
    if (date.getDay() === 1) weekday = 64 // Lunes
    if (date.getDay() === 2) weekday = 32 // Martes
    if (date.getDay() === 3) weekday = 16 // Miércoles
    if (date.getDay() === 4) weekday = 8  // Jueves
    if (date.getDay() === 5) weekday = 4 // Viernes
    if (date.getDay() === 6) weekday = 2 // Sábado

    const yearOffset = Math.max(0, nowParts.year - 2000); //Según la documentación el año Año es (2000 + offset)

    const body: { calendar: number[] } = {
      calendar: [
        nowParts.hour,
        nowParts.minute,
        nowParts.second,
        weekday,
        nowParts.day,
        nowParts.month,
        yearOffset
      ]
    };

    console.log('hora a sincronizar ', body);

    this._device.setModuleCfg(this.serial, body , 'calendar').subscribe({
      next: (data) => {
        console.log('respuesta set clock ', data);
        this.addCorrectionToSunTimes();
        this.loadingClockSync = false;
      },
      error: (error) => {
        console.error('error set clock ', error);
        this.loadingClockSync = false;
      }
    });

  }

  changeOutput(output: number) {
    switch (output) {
      case 1:
        if (this.channelInfo?.stat?.c1stat == 2 ){
          this.channelInfo.stat.c1stat = 1
        }else if (this.channelInfo?.stat?.c1stat == 3){
          this.channelInfo.stat.c1stat = 0
        }else if  (this.channelInfo?.stat?.c1stat == 0){
          this.channelInfo.stat.c1stat = 3
        }else{
          this.channelInfo.stat.c1stat = 2
        }
        break;
      case 2:
        if (this.channelInfo?.stat?.c2stat == 2 ){
          this.channelInfo.stat.c2stat = 1
        }else if (this.channelInfo?.stat?.c2stat == 3){
          this.channelInfo.stat.c2stat = 0
        }else if  (this.channelInfo?.stat?.c2stat == 0){
          this.channelInfo.stat.c2stat = 3
        }else{
          this.channelInfo.stat.c2stat = 2
        }
        break;
      default:
        break;
    }
    if (output == 1) this.loadState.c1 = true;
    if (output == 2) this.loadState.c2 = true;
    const body = {
      c1stat: this.channelInfo?.stat?.c1stat,
      c2stat: this.channelInfo?.stat?.c2stat
    }
    this._device.setModuleCmd(this.serial, body, 'channel', 'relay').subscribe(data =>{
      this.lastConnection = new Date().toISOString();
        console.log('respuesta set channel ', data);
        setTimeout(() => {
          this.loadState.c1 = false;
          this.loadState.c2 = false;
        }, 1000);
      })

    }



  private getNowWeekMinute(now = new Date()): number {
    const dayIndexMon0 = (now.getDay() + 6) % 7; // Lunes=0 ... Domingo=6
    return dayIndexMon0 * this.minutesPerDay + now.getHours() * 60 + now.getMinutes();
  }

  private parseClockParts(clock: any): { year: number; month: number; day: number; hour: number; minute: number; second: number } | null {
    const hour = Number(clock?.hour);
    const minute = Number(clock?.minute);
    const second = Number(clock?.seconds ?? 0);
    const day = Number(clock?.day);
    const month = Number(clock?.month);
    const yearRaw = Number(clock?.year);

    if ([hour, minute, second, day, month, yearRaw].some((value) => !Number.isFinite(value))) {
      return null;
    }

    const year = yearRaw < 100 ? (2000 + yearRaw) : yearRaw;
    return { year, month, day, hour, minute, second };
  }

  private getNowPartsForTimeZone(timeZone: string): { year: number; month: number; day: number; hour: number; minute: number; second: number } | null {
    if (!timeZone) return null;

    try {
      const dtf = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      const parts = dtf.formatToParts(new Date());
      const values: Record<string, string> = {};
      for (const p of parts) {
        if (p.type !== 'literal') values[p.type] = p.value;
      }

      const year = Number(values.year);
      const month = Number(values.month);
      const day = Number(values.day);
      const hour = Number(values.hour);
      const minute = Number(values.minute);
      const second = Number(values.second);

      if ([year, month, day, hour, minute, second].some((value) => !Number.isFinite(value))) {
        return null;
      }

      return { year, month, day, hour, minute, second };
    } catch {
      return null;
    }
  }

  private validateDeviceClockAgainstTimezone(clock: any): void {
    const deviceParts = this.parseClockParts(clock);
    const nowParts = this.getNowPartsForTimeZone(this.timeZone);

    if (!deviceParts || !nowParts) {
      this.deviceClockDriftMinutes = null;
      this.warning = false;
      return;
    }

    const deviceAsUtc = Date.UTC(
      deviceParts.year,
      deviceParts.month - 1,
      deviceParts.day,
      deviceParts.hour,
      deviceParts.minute,
      deviceParts.second,
      0
    );

    const expectedAsUtc = Date.UTC(
      nowParts.year,
      nowParts.month - 1,
      nowParts.day,
      nowParts.hour,
      nowParts.minute,
      nowParts.second,
      0
    );

    const driftMinutes = Math.round((deviceAsUtc - expectedAsUtc) / 60000);
    this.deviceClockDriftMinutes = driftMinutes;
    this.warning = Math.abs(driftMinutes) > this.clockDriftWarningThresholdMinutes;
  }

  private syncDeviceClockReference(clock: any): void {
    const parts = this.parseClockParts(clock);
    if (!parts) {
      this.deviceClockBaseDate = null;
      this.deviceClockCapturedAtMs = null;
      return;
    }

    const baseDate = new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second, 0);

    if (!Number.isFinite(baseDate.getTime())) {
      this.deviceClockBaseDate = null;
      this.deviceClockCapturedAtMs = null;
      return;
    }

    this.deviceClockBaseDate = baseDate;
    this.deviceClockCapturedAtMs = Date.now();
  }

  private getReferenceNow(): Date {
    if (this.deviceClockBaseDate && this.deviceClockCapturedAtMs != null) {
      const elapsedMs = Math.max(0, Date.now() - this.deviceClockCapturedAtMs);
      return new Date(this.deviceClockBaseDate.getTime() + elapsedMs);
    }

    return new Date();
  }

  private getCurrentWeekMinute(): number {
    return this.getNowWeekMinute(this.getReferenceNow());
  }

  private formatCurrentClockTime(): string {
    const now = this.getReferenceNow();
    const hh = String(now.getHours()).padStart(2, '0');
    const mm = String(now.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  private getWindowRangeAroundNow(nowWeekMinute = this.getCurrentWeekMinute()): { min: number; max: number } {
    // Extendemos 1 día a izquierda y derecha para que el "ayer" exista incluso en Lunes.
    const extendedMin = -this.minutesPerDay;
    const extendedMax = (this.weekMinutes - 1) + this.minutesPerDay;

    const snap = Math.max(1, Math.trunc(this.nowSnapMinutes));
    const snappedNowWeekMinute = Math.floor(nowWeekMinute / snap) * snap;

    const minRaw = Math.max(extendedMin, snappedNowWeekMinute - this.windowBackMinutes);
    const maxRaw = Math.min(extendedMax, snappedNowWeekMinute + this.windowForwardMinutes);

    // Alinear a múltiplos de 2h para que las etiquetas (cada 2h) caigan en :00
    const step = 120;
    const minAligned = Math.floor(minRaw / step) * step;
    const maxAligned = Math.ceil(maxRaw / step) * step;

    const min = Math.max(extendedMin, minAligned);
    const max = Math.min(extendedMax, maxAligned);
    return { min, max: Math.max(min + 1, max) };
  }

  private getHolidayNumericValue(value: any): number | null {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  }

  private parseHolidayTimeParts(hourValue: any, minuteValue?: any, hourText?: any): { h: number; m: number } | null {
    const numericHour = this.getHolidayNumericValue(hourValue);
    const numericMinute = this.getHolidayNumericValue(minuteValue);

    if (numericHour != null && numericMinute != null) {
      if (numericHour < 0 || numericHour > 23 || numericMinute < 0 || numericMinute > 59) return null;
      return { h: numericHour, m: numericMinute };
    }

    const text = typeof hourText === 'string' && hourText.includes(':')
      ? hourText
      : (typeof hourValue === 'string' && hourValue.includes(':') ? hourValue : null);

    if (!text) return null;

    const [hhRaw, mmRaw] = text.split(':');
    const h = Number(hhRaw);
    const m = Number(mmRaw);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
    if (h < 0 || h > 23 || m < 0 || m > 59) return null;
    return { h, m };
  }

  private isValidHolidayMonthDay(year: number, month: number, day: number): boolean {
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return false;
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;

    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === (month - 1) && date.getDate() === day;
  }

  private buildHolidayDate(year: number, month: number, day: number, time: { h: number; m: number }): Date | null {
    if (!this.isValidHolidayMonthDay(year, month, day)) return null;
    return new Date(year, month - 1, day, time.h, time.m, 0, 0);
  }

  private buildHolidayRangeForYear(period: any, year: number): { start: Date; end: Date; periodIndex: number } | null {
    if (!period || ('enable' in period && Number(period.enable) !== 1)) return null;

    const sd = Number(period.startDay);
    const sm = Number(period.startMonth);
    const ed = Number(period.endDay);
    const em = Number(period.endMonth);
    if ([sd, sm, ed, em].some((value) => !Number.isFinite(value))) return null;

    const startTime = this.parseHolidayTimeParts(period.startHour, period.startMinute, period.startHourStr);
    const endTime = this.parseHolidayTimeParts(period.endHour, period.endMinute, period.endHourStr);
    if (!startTime || !endTime) return null;

    const start = this.buildHolidayDate(year, sm, sd, startTime);
    if (!start) return null;

    let endYear = year;
    if (em < sm || (em === sm && (ed < sd || (ed === sd && (endTime.h < startTime.h || (endTime.h === startTime.h && endTime.m < startTime.m)))))) {
      endYear = year + 1;
    }

    const end = this.buildHolidayDate(endYear, em, ed, endTime);
    if (!end || end.getTime() < start.getTime()) return null;

    const periodIndex = Number(this.getHolidayNumericValue(period.period) ?? 0);
    return { start, end, periodIndex };
  }

  private getHolidayRangesAroundDate(period: any, referenceDate: Date): Array<{ start: Date; end: Date; periodIndex: number }> {
    const baseYear = referenceDate.getFullYear();
    const ranges = [
      this.buildHolidayRangeForYear(period, baseYear - 1),
      this.buildHolidayRangeForYear(period, baseYear),
      this.buildHolidayRangeForYear(period, baseYear + 1),
    ].filter((range): range is { start: Date; end: Date; periodIndex: number } => !!range);

    return ranges.filter((range, index, all) => {
      return all.findIndex((candidate) =>
        candidate.periodIndex === range.periodIndex &&
        candidate.start.getTime() === range.start.getTime() &&
        candidate.end.getTime() === range.end.getTime()
      ) === index;
    });
  }


  private createWeekDataForChart(programData: any[], activeFestive: number = 0, channelFilter?: number): number[] {
    const MINUTES = this.minutesPerDay;
    const WEEK_MINUTES = this.weekMinutes;

    const clampMinute = (m: number) => Math.max(0, Math.min(MINUTES - 1, Math.trunc(m)));

    const parseTimeToMinutes = (hhmm: string): number => {
      const [hh, mm] = (hhmm || '00:00').split(':').map(Number);
      return clampMinute((hh || 0) * 60 + (mm || 0));
    };

    const toOnOff = (type: any): 0 | 1 => (Number(type) === 1 ? 1 : 0);

    const getSunBasesForDay = (targetDayBit: number): { sunriseBase: number; sunsetBase: number } => {
      let sunriseBase = 0;
      let sunsetBase = 0;

      const dayObj = this.daysOfWeek.find(d => d.value === targetDayBit);
      if (dayObj && Array.isArray(this.sunTimesData) && this.sunTimesData.length > 0) {
        const targetDayName = String(dayObj.label || '').toLowerCase();
        const sunDay = this.sunTimesData.find((s: any) => s && s.weekday && String(s.weekday).toLowerCase() === targetDayName);
        if (sunDay) {
          sunriseBase = typeof sunDay.sunriseMin === 'number' ? clampMinute(sunDay.sunriseMin) : parseTimeToMinutes(sunDay.sunriseStr);
          sunsetBase = typeof sunDay.sunsetMin === 'number' ? clampMinute(sunDay.sunsetMin) : parseTimeToMinutes(sunDay.sunsetStr);
        }
      }

      return { sunriseBase, sunsetBase };
    };

    // Resolver orto/ocaso del día seleccionado desde sunTimesData (mismo criterio que los plugins)
  const { sunriseBase, sunsetBase } = { sunriseBase: 0, sunsetBase: 0 };

    const matchesChannel = (ch: any): boolean => {
      const channel = Number(ch) || 0;
      if (!channelFilter) return channel !== 0;
      if (channelFilter === 1) return channel === 1 || channel === 3;
      if (channelFilter === 2) return channel === 2 || channel === 3;
      return channel !== 0;
    };

    const resolveMinute = (p: any, sunBases?: { sunriseBase: number; sunsetBase: number }): number | null => {
      const mode = Number(p?.mode);
      const t = Number(p?.time) || 0;

      const sun = sunBases ?? { sunriseBase, sunsetBase };

      // 16 = hora fija (time = minutos 0..1439)
      if (mode === 16) return clampMinute(t);
      // 4 = INIC REDUC (siempre hora fija programada)
      if (mode === 4) return clampMinute(t);
      // 8 = FIN REDUC (hora fija; puede ser ON)
      if (mode === 8) return clampMinute(t);
      // 2 = orto (time = offset en minutos)
      if (mode === 2) return clampMinute(sun.sunriseBase + t);
      // 1 = ocaso (time = offset en minutos)
      if (mode === 1) return clampMinute(sun.sunsetBase + t);

      return null;
    };

    const buildEventsForDay = (targetDayBit: number, sunBases?: { sunriseBase: number; sunsetBase: number }) => {
      type Event = { minute: number; value: 0 | 1; mode: number; priority: number };

      const rawEvents: Event[] = (programData || [])
        .filter((p: any) => {
          const daymask = Number(p?.daymask) || 0;
          if ((daymask & targetDayBit) === 0) return false;

          const festive = Number(p?.festive) || 0;
          if (festive !== Number(activeFestive || 0)) return false;

          return matchesChannel(p?.channel);
        })
        .map((p: any) => {
          const minute = resolveMinute(p, sunBases);
          if (minute === null) return null;

          const mode = Number(p?.mode) || 0;
          const value = toOnOff(p?.type) as 0 | 1;
          // Orden para empates (mismo minuto): prioridad alta se aplica al final.
          // - mode 4 (INIC REDUC) tiene prioridad sobre mode 1
          // - mode 2 debe poder imponerse sobre mode 8 (FIN REDUC) si coinciden
          const priority = mode === 4 ? 3 : mode === 2 ? 2 : 1;
          return { minute, value, mode, priority } as Event;
        })
        .filter((e: any): e is Event => !!e);

      // Prioridad solicitada:
      // Si existe un apagado (OFF) en mode=4 anterior en el mismo día/canal/festivo,
      // un encendido (ON) posterior en mode=1 NO debe ejecutarse.
      const mode4OffMinutes = rawEvents
        .filter((e) => e.mode === 4 && e.value === 0)
        .map((e) => e.minute)
        .sort((a, b) => a - b);

      const mode2OffMinutes = rawEvents
        .filter((e) => e.mode === 2 && e.value === 0)
        .map((e) => e.minute)
        .sort((a, b) => a - b);

      const sunriseMinute = sunBases?.sunriseBase ?? 0;

      const filtered = rawEvents.filter((e) => {
        if (e.mode === 1 && e.value === 1 && mode4OffMinutes.length > 0) {
          // INIC REDUC solo bloquea OCASO si cae entre orto y ocaso (período diurno).
          // Horas nocturnas tempranas (p. ej. 00:00–01:00) son continuación del ciclo anterior.
          const ocasoMinute = e.minute;
          const hasBlockingMode4Off = mode4OffMinutes.some(
            (m4) => m4 >= sunriseMinute && m4 <= ocasoMinute
          );
          return !hasBlockingMode4Off;
        }

        if (e.mode === 8 && e.value === 1 && mode2OffMinutes.length > 0) {
          // FIN REDUC (mode=8) NO tiene prioridad respecto al mode=2.
          // ORTO solo bloquea FIN REDUC si cae entre orto y el propio FIN REDUC.
          const hasBlockingMode2Off = mode2OffMinutes.some(
            (m2) => m2 >= sunriseMinute && m2 <= e.minute
          );
          return !hasBlockingMode2Off;
        }

        return true;
      });

      // Orden estable: primero por minuto, y si coinciden, aplicar prioridad (mode 4 al final).
      filtered.sort((a, b) => (a.minute - b.minute) || (a.priority - b.priority));

      return filtered.map(({ minute, value }) => ({ minute, value }));
    };

    const computeWeek = (initialMonday: 0 | 1): { data: number[]; endValue: 0 | 1 } => {
      const data: number[] = new Array(WEEK_MINUTES).fill(0);
      let prevValue: 0 | 1 = initialMonday;

      for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
        const dayBit = this.daysOfWeek[dayIndex].value;
        const sunBases = getSunBasesForDay(dayBit);
        const events = buildEventsForDay(dayBit, sunBases);

        let current: 0 | 1 = prevValue;
        let eventIndex = 0;
        const offset = dayIndex * MINUTES;

        for (let minute = 0; minute < MINUTES; minute++) {
          while (eventIndex < events.length && events[eventIndex].minute <= minute) {
            current = events[eventIndex].value;
            eventIndex++;
          }
          data[offset + minute] = current;
        }

        prevValue = current;
      }

      return { data, endValue: prevValue };
    };

    // Resolver continuidad semana (Domingo->Lunes): 2 pasadas para evitar arranque incorrecto.
    const pass1 = computeWeek(0);
    const pass2 = computeWeek(pass1.endValue);
    return pass2.data;
  }

  private rebuildBothCharts(): void {
    if (this.outputCount < 2) {
      this.chartOut2?.destroy();
      this.chartOut2 = null;
    }

    this.chartDataOut1 = this.createWeekDataForChart(this.programDataFormated, this.todayPeriod?.periodIndex ?? 0, 1);
    this.createChartForOutput(1);

    if (this.outputCount < 2) return;

    this.chartDataOut2 = this.createWeekDataForChart(this.programDataFormated, this.todayPeriod?.periodIndex ?? 0, 2);
    this.createChartForOutput(2);

    // Render overlay once both charts exist
    window.setTimeout(() => this.renderSunLinesOverlay(), 0);
  }

  private refreshExistingCharts(): void {
    // Recalcular datos con los ortos/ocasos/correcciones actuales y refrescar datasets/rango.
    this.chartDataOut1 = this.createWeekDataForChart(this.programDataFormated, this.todayPeriod?.periodIndex ?? 0, 1);
    this.chartDataOut2 = this.createWeekDataForChart(this.programDataFormated, this.todayPeriod?.periodIndex ?? 0, 2);

    this.updateChartPointsAndRange(this.chartOut1, this.chartDataOut1);
    this.updateChartPointsAndRange(this.chartOut2, this.chartDataOut2);

    this.renderSunLinesOverlay();
  }

  private updateChartPointsAndRange(chart: Chart | null, chartData: number[]): void {
    if (!chart) return;

    const points: Array<{ x: number; y: number }> = [];

    for (let minute = 0; minute < this.minutesPerDay; minute++) {
      const y = chartData[(this.weekMinutes - this.minutesPerDay) + minute] ?? 0;
      points.push({ x: minute - this.minutesPerDay, y });
    }

    for (let x = 0; x < this.weekMinutes; x++) {
      points.push({ x, y: chartData[x] ?? 0 });
    }

    for (let minute = 0; minute < this.minutesPerDay; minute++) {
      const y = chartData[minute] ?? 0;
      points.push({ x: this.weekMinutes + minute, y });
    }

    chart.data.datasets[0].data = points as any;

    const r = this.getWindowRangeAroundNow();
    const xScale = (chart.options.scales as any)?.x;
    if (xScale) {
      xScale.min = r.min;
      xScale.max = r.max;
    }

    chart.update('none');
  }

  private renderSunLinesOverlay(): void {
    const chart1 = this.chartOut1;
    const chart2 = this.chartOut2;
    if (!chart1 || !chart2) return;
    if (!this.overlayContainer?.nativeElement || !this.sunLinesOverlay?.nativeElement) return;
    if (!Array.isArray(this.sunTimesData) || this.sunTimesData.length === 0) return;

    const containerEl = this.overlayContainer.nativeElement;
    const overlayCanvas = this.sunLinesOverlay.nativeElement;

    const containerRect = containerEl.getBoundingClientRect();
    const rect1 = (chart1.canvas as HTMLCanvasElement).getBoundingClientRect();
    const rect2 = (chart2.canvas as HTMLCanvasElement).getBoundingClientRect();

    const widthCss = Math.max(1, Math.round(containerRect.width));
    const heightCss = Math.max(1, Math.round(containerRect.height));

    const dpr = window.devicePixelRatio || 1;
    overlayCanvas.width = Math.round(widthCss * dpr);
    overlayCanvas.height = Math.round(heightCss * dpr);

    const ctx = overlayCanvas.getContext('2d');
    if (!ctx) return;

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, widthCss, heightCss);

    const offsetX1 = rect1.left - containerRect.left;
    const offsetY1 = rect1.top - containerRect.top;
    const offsetY2 = rect2.top - containerRect.top;

    const chartArea1 = (chart1 as any).chartArea;
    const chartArea2 = (chart2 as any).chartArea;
    const xScale1 = (chart1 as any).scales?.x;
    if (!chartArea1 || !chartArea2 || !xScale1) return;

    // Línea debe ir desde el top del primer chart hasta el bottom del segundo,
    // y sobresalir un poco por arriba para colocar el globo.
    const yTop = offsetY1 + chartArea1.top;
    const yBottom = offsetY2 + chartArea2.bottom;

    // Subir la línea/globo por encima del carril de noche
    const overshoot = 90;
    const yLineTop = Math.max(0, yTop - overshoot);

    // Desplazamiento vertical de los globos de orto/ocaso respecto a la línea superior
    const bubbleYOffset = 24;

    const drawRoundedRect = (x: number, y: number, w: number, h: number, r: number) => {
      const radius = Math.max(0, Math.min(r, w / 2, h / 2));
      // roundRect está soportado en la mayoría de navegadores modernos, pero dejamos fallback.
      const anyCtx = ctx as any;
      if (typeof anyCtx.roundRect === 'function') {
        anyCtx.roundRect(x, y, w, h, radius);
        return;
      }

      ctx.moveTo(x + radius, y);
      ctx.arcTo(x + w, y, x + w, y + h, radius);
      ctx.arcTo(x + w, y + h, x, y + h, radius);
      ctx.arcTo(x, y + h, x, y, radius);
      ctx.arcTo(x, y, x + w, y, radius);
      ctx.closePath();
    };

    const drawBubble = (xCenter: number, yCenter: number, text: string, bg: string, fg: string, arrowSize = 0) => {
      ctx.save();
      ctx.setLineDash([]);
      ctx.font = 'bold 12px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      const paddingX = 10;
      const paddingY = 6;
      const textWidth = ctx.measureText(text).width;
      const w = textWidth + paddingX * 2;
      const h = 20 + paddingY;

      const minX = w / 2 + 2;
      const maxX = widthCss - w / 2 - 2;
      const x = Math.max(minX, Math.min(maxX, xCenter));

      const minY = h / 2;
      const extraBottom = arrowSize > 0 ? (arrowSize + 2) : 0;
      const maxY = heightCss - h / 2 - 2 - extraBottom;
      const y = Math.max(minY, Math.min(maxY, yCenter));

      ctx.fillStyle = bg;
      ctx.beginPath();
      drawRoundedRect(x - w / 2, y - h / 2, w, h, 10);
      ctx.fill();

      if (arrowSize > 0) {
        const baseY = y + h / 2;
        const tipY = Math.min(heightCss - 2, baseY + arrowSize);
        ctx.beginPath();
        ctx.moveTo(x, tipY);
        ctx.lineTo(x - arrowSize, baseY);
        ctx.lineTo(x + arrowSize, baseY);
        ctx.closePath();
        ctx.fill();
      }

      ctx.fillStyle = fg;
      ctx.fillText(text, x, y);
      ctx.restore();
    };

    const parseTimeToMinute = (timeStr: string) => {
      const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
      return (hh || 0) * 60 + (mm || 0);
    };

    const minX = typeof xScale1.min === 'number' ? xScale1.min : 0;
    const maxX = typeof xScale1.max === 'number' ? xScale1.max : this.weekMinutes - 1;
    const startSlot = Math.floor(minX / this.minutesPerDay);
    const endSlot = Math.floor(maxX / this.minutesPerDay);

    const laneHeight = 24;
    const refNightLineWidth = 14;
    const refNightSeparationFromChart = 18;
    const refHolidayLineWidth = refNightLineWidth;
    const refSeparationBetweenLanes = 6;

    const refYNight = Math.max(refNightLineWidth / 2 + 2, yTop - refNightSeparationFromChart);
    const refHolidayMinY = refHolidayLineWidth / 2 + 2;
    const refHolidayYTarget = refYNight - (refHolidayLineWidth + refSeparationBetweenLanes);
    const refHolidayY = Math.max(refHolidayMinY, refHolidayYTarget);
    const holidayBottomY = refHolidayY + (refHolidayLineWidth / 2);

    const nightLaneTop = Math.max(2, holidayBottomY);
    const nightLaneBottom = Math.max(nightLaneTop + laneHeight, yTop);
    const nightLaneHeight = nightLaneBottom - nightLaneTop;

    const drawNightOverlaySegment = (x1: number, x2: number): void => {
      if (x2 <= x1) return;

      const laneGradient = ctx.createLinearGradient(0, nightLaneTop, 0, nightLaneTop + nightLaneHeight);
      laneGradient.addColorStop(0, 'rgba(154, 162, 173, 0.70)');
      laneGradient.addColorStop(1, 'rgba(154, 162, 173, 0.42)');

      const columnGradient = ctx.createLinearGradient(0, nightLaneTop, 0, yBottom);
      columnGradient.addColorStop(0, 'rgba(154, 162, 173, 0.34)');
      columnGradient.addColorStop(0.45, 'rgba(154, 162, 173, 0.24)');
      columnGradient.addColorStop(1, 'rgba(154, 162, 173, 0.12)');

      ctx.save();
      ctx.fillStyle = columnGradient;
      ctx.fillRect(x1, nightLaneTop, x2 - x1, Math.max(0, yBottom - nightLaneTop));

      ctx.fillStyle = laneGradient;
      ctx.fillRect(x1, nightLaneTop, x2 - x1, nightLaneHeight);
      ctx.restore();
    };

    ctx.save();
    ctx.lineWidth = 2;
    ctx.setLineDash([5, 5]);

    for (let daySlot = startSlot; daySlot <= endSlot; daySlot++) {
      const dayIndex = ((daySlot % 7) + 7) % 7;
      const dayObj = this.daysOfWeek[dayIndex];
      if (!dayObj) continue;

      const targetDayName = String(dayObj.label || '').toLowerCase();
      const sunDay = this.sunTimesData.find((s: any) =>
        s && s.weekday && String(s.weekday).toLowerCase() === targetDayName
      );
      if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) continue;

      const sunriseMinute = parseTimeToMinute(sunDay.sunriseStr);
      const sunsetMinute = parseTimeToMinute(sunDay.sunsetStr);

      const dayStart = daySlot * this.minutesPerDay;
      const dayEnd = dayStart + (this.minutesPerDay - 1);

      const pxDayStart = offsetX1 + xScale1.getPixelForValue(dayStart);
      const pxDayEnd = offsetX1 + xScale1.getPixelForValue(dayEnd);
      if (!Number.isFinite(pxDayStart) || !Number.isFinite(pxDayEnd)) continue;

      const pxOrto = offsetX1 + xScale1.getPixelForValue(dayStart + sunriseMinute);
      if (Number.isFinite(pxOrto)) {
        const x1 = Math.max(offsetX1 + chartArea1.left, Math.min(offsetX1 + chartArea1.right, pxDayStart));
        const x2 = Math.max(offsetX1 + chartArea1.left, Math.min(offsetX1 + chartArea1.right, pxOrto));
        drawNightOverlaySegment(x1, x2);
      }

      const pxOcaso = offsetX1 + xScale1.getPixelForValue(dayStart + sunsetMinute);
      if (Number.isFinite(pxOcaso)) {
        const x1 = Math.max(offsetX1 + chartArea1.left, Math.min(offsetX1 + chartArea1.right, pxOcaso));
        const x2 = Math.max(offsetX1 + chartArea1.left, Math.min(offsetX1 + chartArea1.right, pxDayEnd));
        drawNightOverlaySegment(x1, x2);
      }
    }

    // Línea del momento actual (una sola vez, atravesando ambos gráficos)
    // Se dibuja ANTES que los globos para que no los tape.
    {
      const weekMinute = this.getCurrentWeekMinute();
      const xLocal = xScale1.getPixelForValue(weekMinute);
      const x = offsetX1 + xLocal;

      if (Number.isFinite(x)) {
        // Color  específico para la línea y burbuja de "ahora"
        const primary = '#4267B2';

        // Que quede por encima de la altura del globo de sol/luna
        const extraAboveBubbles = 24;
        const yStart = Math.max(0, yLineTop - extraAboveBubbles);
        const yEnd = yBottom;

        ctx.save();
        ctx.strokeStyle = primary;
        ctx.globalAlpha = 0.65;
        ctx.lineWidth = 2;
        ctx.setLineDash([4, 6]);
        ctx.beginPath();
        ctx.moveTo(x, yStart);
        ctx.lineTo(x, yEnd);
        ctx.stroke();
        ctx.restore();

        // Globo (bocadillo) con flecha hacia abajo, apuntando a la parte superior de la línea
        // Aproximación: alto del globo ~26px => centro ~13px. Con arrowSize=7 => yCenter ≈ yStart - 20.
        const nowBubbleArrowSize = 7;
        drawBubble(
          x,
          yStart - 20,
          `🕒 ${this.formatCurrentClockTime()}`,
          primary,
          '#fff',
          nowBubbleArrowSize
        );
      }
    }

    for (let daySlot = startSlot; daySlot <= endSlot; daySlot++) {
      const dayIndex = ((daySlot % 7) + 7) % 7;
      const dayObj = this.daysOfWeek[dayIndex];
      if (!dayObj) continue;

      const targetDayName = String(dayObj.label || '').toLowerCase();
      const sunDay = this.sunTimesData.find((s: any) =>
        s && s.weekday && String(s.weekday).toLowerCase() === targetDayName
      );
      if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) continue;

      const sunriseMinute = parseTimeToMinute(sunDay.sunriseStr);
      const sunsetMinute = parseTimeToMinute(sunDay.sunsetStr);

      const ortoIndex = (daySlot * this.minutesPerDay) + sunriseMinute;
      const ocasoIndex = (daySlot * this.minutesPerDay) + sunsetMinute;

      // Si el evento no está dentro del rango visible actual, no dibujar (evita globos “clampados” en el borde).
      const ortoVisible = ortoIndex >= minX && ortoIndex <= maxX;
      const ocasoVisible = ocasoIndex >= minX && ocasoIndex <= maxX;

      if (!ortoVisible && !ocasoVisible) continue;

      const ortoXLocal = ortoVisible ? xScale1.getPixelForValue(ortoIndex) : NaN;
      const ocasoXLocal = ocasoVisible ? xScale1.getPixelForValue(ocasoIndex) : NaN;
      const ortoX = offsetX1 + ortoXLocal;
      const ocasoX = offsetX1 + ocasoXLocal;

      if (Number.isFinite(ortoX)) {
        //  la raya justo por debajo de la parte inferior del globo.
        const markerTopY = yLineTop + bubbleYOffset + 14;
        ctx.strokeStyle = 'rgba(247, 210, 26, 0.8)';
        ctx.beginPath();
        ctx.moveTo(ortoX, markerTopY);
        ctx.lineTo(ortoX, yBottom);
        ctx.stroke();

        // Globo arriba del primer gráfico
        drawBubble(
          ortoX,
          yLineTop + bubbleYOffset,
          `☀️ ${sunDay.sunriseStr}`,
          'rgba(255, 152, 0, 0.9)',
          '#fff',
          7
        );
      }

      if (Number.isFinite(ocasoX)) {
        ctx.strokeStyle = 'rgba(108, 117, 125, 0.8)';
        ctx.beginPath();
        // Misma lógica que para el orto: arrancar la línea
        const markerTopY = yLineTop + bubbleYOffset + 14;
        ctx.moveTo(ocasoX, markerTopY);
        ctx.lineTo(ocasoX, yBottom);
        ctx.stroke();

        drawBubble(
          ocasoX,
          yLineTop + bubbleYOffset,
          `🌙 ${sunDay.sunsetStr}`,
          'rgba(108, 117, 125, 0.9)',
          '#fff',
          7
        );
      }
    }

    ctx.restore();
  }

  private createChartForOutput(output: 1 | 2): void {

    // Reiniciar intervalo una única vez (da igual desde qué salida se invoque)
    if (this.nowLineTimerId != null) {
      window.clearInterval(this.nowLineTimerId);
      this.nowLineTimerId = null;
    }

    const canvasRef = output === 1 ? this.editCanvasOut1 : this.editCanvasOut2;
    if (!canvasRef?.nativeElement) return;

    // (re)destruye por si ya había uno
    if (output === 1) {
      this.chartOut1?.destroy();
      this.chartOut1 = null;
    } else {
      this.chartOut2?.destroy();
      this.chartOut2 = null;
    }

    const ctx = canvasRef.nativeElement.getContext('2d');
    if (!ctx) return;

    const chartData = output === 1 ? this.chartDataOut1 : this.chartDataOut2;
    if (!Array.isArray(chartData) || chartData.length !== this.weekMinutes) {
      // Fallback defensivo
      const rebuilt = this.createWeekDataForChart(this.programDataFormated, this.todayPeriod?.periodIndex ?? 0, output);
      if (output === 1) this.chartDataOut1 = rebuilt;
      else this.chartDataOut2 = rebuilt;
    }

    const range = this.getWindowRangeAroundNow();

    const buildExtendedPoints = (): Array<{ x: number; y: number }> => {
      const points: Array<{ x: number; y: number }> = [];

      // Día anterior (Domingo) a la izquierda: x = [-1440..-1]
      const data = output === 1 ? this.chartDataOut1 : this.chartDataOut2;

      for (let minute = 0; minute < this.minutesPerDay; minute++) {
        const y = data[(this.weekMinutes - this.minutesPerDay) + minute] ?? 0;
        points.push({ x: minute - this.minutesPerDay, y });
      }

      // Semana completa: x = [0..10079]
      for (let x = 0; x < this.weekMinutes; x++) {
        points.push({ x, y: data[x] ?? 0 });
      }

      // Día siguiente (Lunes) a la derecha: x = [10080..11519]
      for (let minute = 0; minute < this.minutesPerDay; minute++) {
        const y = data[minute] ?? 0;
        points.push({ x: this.weekMinutes + minute, y });
      }

      return points;
    };

    const points = buildExtendedPoints();

    const formatWeekMinute = (weekMinute: number): string => {
      const x = Math.trunc(weekMinute);
      const daySlot = Math.floor(x / this.minutesPerDay); // puede ser -1..7
      const dayIndex = ((daySlot % 7) + 7) % 7; // 0..6
      const minuteOfDay = ((x % this.minutesPerDay) + this.minutesPerDay) % this.minutesPerDay;
      const hh = String(Math.floor(minuteOfDay / 60)).padStart(2, '0');
      const mm = String(minuteOfDay % 60).padStart(2, '0');
      const dayShort = this.daysOfWeek[dayIndex]?.short ?? '';
      return dayShort ? `${dayShort} ${hh}:${mm}` : `${hh}:${mm}`;
    };

    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        datasets: [{
          // Colores por estado del canal: ON amarillo, OFF gris.
          segment: {
            borderColor: (segmentCtx: any) => {
              const y0 = Number(segmentCtx?.p0?.parsed?.y ?? 0);
              const y1 = Number(segmentCtx?.p1?.parsed?.y ?? 0);
              return (y0 === 0 && y1 === 0) ? '#6c757d' : '#f7d21a';
            }
          },
          data: points,             // 10080 puntos {x,y} con x=minuto de semana
          stepped: true,
          fill: true,                // relleno del área bajo la línea
          backgroundColor: 'rgba(247, 210, 26, 0.1)',  // relleno amarillo con baja opacidad
          borderWidth: 5,            // más visible
          pointRadius: 0,
          borderColor: '#f7d21a',    // fallback (el color real se define por segmento)
          spanGaps: true,            // por si hubiera undefined (no debería, pero ayuda)
        }]
      },
      options: {
        animation: false,
        // parsing:false removed so Chart.js will handle numeric arrays normally
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 105,
          }
        },
        scales: {
          // Forzar rango explícito a 0 y 1 (sin padding extra)
          y: { min: 0, max: 1, ticks: { stepSize: 1, callback: (v) => (v === 1 ? this.translate.instant('on') : v === 0 ? this.translate.instant('off') : '') } },
          x: {
            type: 'linear',
            min: range.min,
            max: range.max,
            ticks: {
              autoSkip: false,
              stepSize: 120,
              maxRotation: 0,
              callback: (value: any) => {
                const x = Math.trunc(Number(value));
                if (!Number.isFinite(x)) return '';

                const minuteOfDay = ((x % this.minutesPerDay) + this.minutesPerDay) % this.minutesPerDay;
                const hour = Math.floor(minuteOfDay / 60);
                if (hour === 0) return '🕛';
                return `${String(hour).padStart(2, '0')}:00`;
              }
            }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => {
                const x = items?.[0]?.parsed?.x;
                return typeof x === 'number' ? formatWeekMinute(x) : '';
              },
              label: (ctx) => (ctx.parsed.y ? this.translate.instant('switched_on') : this.translate.instant('switched_off'))
            }
          }
        },
        elements: {
          line: {
            // asegura que no haya suavizado que "aplane" microtramos
            tension: 0
          }
        }
      },
      plugins: [{
        id: 'channelLabel',
        afterDraw: (chart: any) => {
          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const yScale = chart.scales?.y;
          if (!ctx || !chartArea || !yScale) return;

          const rootStyle = getComputedStyle(document.documentElement);
          const secondary = (rootStyle.getPropertyValue('--bs-secondary') || rootStyle.getPropertyValue('--secondary') || '').trim() || '#6c757d';

          const label = `${this.translate.instant('channel')} ${output}`;
          // Colocar en vertical en la zona del eje Y (donde están ON/OFF), fuera del área del gráfico.
          const x = yScale.left + 12;
          const y = (yScale.top + yScale.bottom) / 2;

          ctx.save();
          ctx.fillStyle = secondary;
          ctx.globalAlpha = 0.65;
          ctx.font = '600 12px sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.translate(x, y);
          ctx.rotate(-Math.PI / 2);
          ctx.fillText(label, 0, 0);
          ctx.restore();
        }
      }, {
        id: 'nightLane',
        beforeDatasetsDraw: (chart: any) => {
          if (this.chartOut1 && this.chartOut2) {
            return;
          }

          if (!this.sunTimesData || !Array.isArray(this.sunTimesData) || this.sunTimesData.length === 0) {
            return;
          }

          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const xScale = chart.scales.x;
          if (!chartArea || !xScale) return;

          const parseTime = (timeStr: string) => {
            const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
            return (hh || 0) * 60 + (mm || 0);
          };

          const minX = typeof xScale.min === 'number' ? xScale.min : 0;
          const maxX = typeof xScale.max === 'number' ? xScale.max : this.weekMinutes - 1;
          const startSlot = Math.floor(minX / this.minutesPerDay);
          const endSlot = Math.floor(maxX / this.minutesPerDay);

          // Carril ancho por encima del gráfico para indicar noche (00:00->orto y ocaso->24:00)
          const laneHeight = 24;

          // Alinear con el carril festivo: que el borde superior del carril nocturno
          // toque el borde inferior del carril de periodos (sin solaparse).
          const refNightLineWidth = 14;
          const refNightSeparationFromChart = 18;
          const refHolidayLineWidth = refNightLineWidth;
          const refSeparationBetweenLanes = 6;

          const refYNight = Math.max(refNightLineWidth / 2 + 2, chartArea.top - refNightSeparationFromChart);
          const refHolidayMinY = refHolidayLineWidth / 2 + 2;
          const refHolidayYTarget = refYNight - (refHolidayLineWidth + refSeparationBetweenLanes);
          const refHolidayY = Math.max(refHolidayMinY, refHolidayYTarget);
          const holidayBottomY = refHolidayY + (refHolidayLineWidth / 2);

          const laneTop = Math.max(2, holidayBottomY);
          // Ensanchar hacia abajo hasta tocar el borde superior del gráfico.
          const laneBottom = Math.max(laneTop + laneHeight, chartArea.top);
          const laneHeightFinal = laneBottom - laneTop;

          const drawNightSegment = (x1: number, x2: number): void => {
            if (x2 <= x1) return;

            const laneGradient = ctx.createLinearGradient(0, laneTop, 0, laneTop + laneHeightFinal);
            laneGradient.addColorStop(0, 'rgba(154, 162, 173, 0.70)');
            laneGradient.addColorStop(1, 'rgba(154, 162, 173, 0.42)');

            const chartGradient = ctx.createLinearGradient(0, laneTop, 0, chartArea.bottom);
            chartGradient.addColorStop(0, 'rgba(154, 162, 173, 0.34)');
            chartGradient.addColorStop(0.45, 'rgba(154, 162, 173, 0.24)');
            chartGradient.addColorStop(1, 'rgba(154, 162, 173, 0.12)');

            ctx.fillStyle = chartGradient;
            ctx.fillRect(x1, chartArea.top, x2 - x1, chartArea.bottom - chartArea.top);

            ctx.fillStyle = laneGradient;
            ctx.fillRect(x1, laneTop, x2 - x1, laneHeightFinal);
          };


          ctx.save();

          for (let daySlot = startSlot; daySlot <= endSlot; daySlot++) {
            const dayIndex = ((daySlot % 7) + 7) % 7;
            const dayObj = this.daysOfWeek[dayIndex];
            if (!dayObj) continue;

            const targetDayName = String(dayObj.label || '').toLowerCase();
            const sunDay = this.sunTimesData.find((s: any) =>
              s && s.weekday && String(s.weekday).toLowerCase() === targetDayName
            );
            if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) continue;

            const sunriseMinute = parseTime(sunDay.sunriseStr);
            const sunsetMinute = parseTime(sunDay.sunsetStr);

            const dayStart = daySlot * this.minutesPerDay;
            const dayEnd = dayStart + (this.minutesPerDay - 1);

            const pxDayStart = xScale.getPixelForValue(dayStart);
            const pxDayEnd = xScale.getPixelForValue(dayEnd);
            if (!Number.isFinite(pxDayStart) || !Number.isFinite(pxDayEnd)) continue;

            // Noche tramo 1: 00:00 -> orto
            {
              const pxOrto = xScale.getPixelForValue(dayStart + sunriseMinute);
              if (Number.isFinite(pxOrto)) {
                const x1 = Math.max(chartArea.left, Math.min(chartArea.right, pxDayStart));
                const x2 = Math.max(chartArea.left, Math.min(chartArea.right, pxOrto));
                drawNightSegment(x1, x2);
              }
            }

            // Noche tramo 2: ocaso -> 24:00
            {
              const pxOcaso = xScale.getPixelForValue(dayStart + sunsetMinute);
              if (Number.isFinite(pxOcaso)) {
                const x1 = Math.max(chartArea.left, Math.min(chartArea.right, pxOcaso));
                const x2 = Math.max(chartArea.left, Math.min(chartArea.right, pxDayEnd - 0.5));
                drawNightSegment(x1, x2);
              }
            }
          }

          ctx.restore();
        }
      }, {
        id: 'ortoOcasoLinesModal',
        afterDraw: (chart: any) => {
          // En modo 2 salidas, las líneas verticales se dibujan en un overlay único (entre ambos charts).
          // Este plugin se deja sin dibujo para evitar duplicados dentro de cada canvas.
          if (this.chartOut1 && this.chartOut2) return;

          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const xScale = chart.scales.x;

          if (!this.sunTimesData || !Array.isArray(this.sunTimesData) || this.sunTimesData.length === 0) {
            return; // No hay datos de orto/ocaso
          }

          const parseTime = (timeStr: string) => {
            const [hh, mm] = (timeStr || '00:00').split(':').map(Number);
            return { hour: hh || 0, minute: mm || 0 };
          };

          const minX = typeof xScale.min === 'number' ? xScale.min : 0;
          const maxX = typeof xScale.max === 'number' ? xScale.max : this.weekMinutes - 1;
          const startSlot = Math.floor(minX / this.minutesPerDay);
          const endSlot = Math.floor(maxX / this.minutesPerDay);

          for (let daySlot = startSlot; daySlot <= endSlot; daySlot++) {
            const dayIndex = ((daySlot % 7) + 7) % 7;
            const dayObj = this.daysOfWeek[dayIndex];
            if (!dayObj) continue;

            const targetDayName = String(dayObj.label || '').toLowerCase();
            const sunDay = this.sunTimesData.find((s: any) => {
              return s && s.weekday && String(s.weekday).toLowerCase() === targetDayName;
            });

            if (!sunDay || !sunDay.sunriseStr || !sunDay.sunsetStr) continue;

            const ortoTime = parseTime(sunDay.sunriseStr);
            const ocasoTime = parseTime(sunDay.sunsetStr);
            const ortoIndex = (daySlot * this.minutesPerDay) + (ortoTime.hour * 60 + ortoTime.minute);
            const ocasoIndex = (daySlot * this.minutesPerDay) + (ocasoTime.hour * 60 + ocasoTime.minute);

            const ortoX = xScale.getPixelForValue(ortoIndex);
            const ocasoX = xScale.getPixelForValue(ocasoIndex);

            if (!Number.isFinite(ortoX) || !Number.isFinite(ocasoX)) continue;

            ctx.save();
            ctx.lineWidth = 2;
            ctx.setLineDash([5, 5]); // Línea discontinua

            // Línea de orto (amarillo personalizado)
            ctx.strokeStyle = 'rgba(247, 210, 26, 0.8)';
            ctx.beginPath();
            ctx.moveTo(ortoX, chartArea.top);
            ctx.lineTo(ortoX, chartArea.bottom);
            ctx.stroke();

            // Línea de ocaso (azul oscuro/gris)
            ctx.strokeStyle = 'rgba(108, 117, 125, 0.8)';
            ctx.beginPath();
            ctx.moveTo(ocasoX, chartArea.top);
            ctx.lineTo(ocasoX, chartArea.bottom);
            ctx.stroke();

            ctx.setLineDash([]);

            ctx.restore();
          }
        }
      }, {
        id: 'holidayPeriodLine',
        afterDraw: (chart: any) => {
          if (!this.showHolidayPeriodLane) return;

          // Los periodos festivos aplican a ambas salidas; se dibuja una sola vez (salida 1)
          if (output !== 1) return;

          const periods = this.holidayInfo?.periods;
          if (!Array.isArray(periods) || periods.length === 0) return;

          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const xScale = chart.scales.x;
          if (!xScale || !chartArea) return;

          const now = this.getReferenceNow();
          const currentWeekMinute = this.getNowWeekMinute(now);

          const minX = typeof xScale.min === 'number' ? xScale.min : 0;
          const maxX = typeof xScale.max === 'number' ? xScale.max : this.weekMinutes - 1;

          const windowStart = new Date(now.getTime() + (minX - currentWeekMinute) * 60_000);
          const windowEnd = new Date(now.getTime() + (maxX - currentWeekMinute) * 60_000);

          const rootStyle = getComputedStyle(document.documentElement);
          // Soportar Bootstrap v5 (--bs-*) y v4 (sin prefijo --bs-)
          const bsPrimary = (rootStyle.getPropertyValue('--bs-primary') || rootStyle.getPropertyValue('--primary') || '').trim() || '#0d6efd';
          const bsSuccess = (rootStyle.getPropertyValue('--bs-success') || rootStyle.getPropertyValue('--success') || '').trim() || '#39b690';
          const bsDanger = (rootStyle.getPropertyValue('--bs-danger') || rootStyle.getPropertyValue('--danger') || '').trim() || '#dc3545';
          const bsSecondary = (rootStyle.getPropertyValue('--bs-secondary') || rootStyle.getPropertyValue('--secondary') || '').trim() || '#6c757d';
          const bsLight = (rootStyle.getPropertyValue('--bs-light') || rootStyle.getPropertyValue('--light') || '').trim() || '#f8f9fa';

          const colorForPeriod = (periodIndex: number): string => {
            if (periodIndex === 1) return bsPrimary;
            if (periodIndex === 2) return bsSuccess;
            if (periodIndex === 3) return bsDanger;
            if (periodIndex === 4) return bsSecondary;
            return bsLight;
          };

          const toRgba = (color: string, alpha: number): string => {
            const c = String(color || '').trim();
            const a = Math.max(0, Math.min(1, alpha));

            // rgb/rgba
            const rgbMatch = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([0-9.]+))?\s*\)$/i);
            if (rgbMatch) {
              const r = Number(rgbMatch[1]);
              const g = Number(rgbMatch[2]);
              const b = Number(rgbMatch[3]);
              return `rgba(${r}, ${g}, ${b}, ${a})`;
            }

            // #RGB or #RRGGBB
            const hexMatch = c.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
            if (hexMatch) {
              const hex = hexMatch[1];
              const full = hex.length === 3
                ? hex.split('').map((ch) => ch + ch).join('')
                : hex;
              const r = parseInt(full.slice(0, 2), 16);
              const g = parseInt(full.slice(2, 4), 16);
              const b = parseInt(full.slice(4, 6), 16);
              return `rgba(${r}, ${g}, ${b}, ${a})`;
            }

            // Fallback: usar el color tal cual
            return c;
          };

          const toRgb = (color: string): { r: number; g: number; b: number } | null => {
            const c = String(color || '').trim();

            const rgbMatch = c.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([0-9.]+))?\s*\)$/i);
            if (rgbMatch) {
              return { r: Number(rgbMatch[1]), g: Number(rgbMatch[2]), b: Number(rgbMatch[3]) };
            }

            const hexMatch = c.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
            if (hexMatch) {
              const hex = hexMatch[1];
              const full = hex.length === 3
                ? hex.split('').map((ch) => ch + ch).join('')
                : hex;
              const r = parseInt(full.slice(0, 2), 16);
              const g = parseInt(full.slice(2, 4), 16);
              const b = parseInt(full.slice(4, 6), 16);
              return { r, g, b };
            }

            return null;
          };

          const tintToRgba = (baseColor: string, tintToWhite: number, alpha: number): string => {
            const t = Math.max(0, Math.min(1, tintToWhite));
            const rgb = toRgb(baseColor);
            if (!rgb) return toRgba(baseColor, alpha);

            const r = Math.round(rgb.r * (1 - t) + 255 * t);
            const g = Math.round(rgb.g * (1 - t) + 255 * t);
            const b = Math.round(rgb.b * (1 - t) + 255 * t);
            return `rgba(${r}, ${g}, ${b}, ${Math.max(0, Math.min(1, alpha))})`;
          };

          type VisibleLaneSegment = {
            startMinute: number;
            endMinute: number;
            periodIndex: number;
          };

          // Dibujar los tramos visibles sobre una misma "línea" (misma altura)
          // para que al cambiar de periodo cambie el color pero no la posición.
          let drawnSegments = 0;
          const maxSegments = 8;

          ctx.save();
          ctx.lineCap = 'round';

          // Dibujar por encima del gráfico (fuera del chartArea) y siempre por encima del carril de noche
          const nightLineWidth = 14;
          const nightSeparationFromChart = 18;
          const yNight = Math.max(nightLineWidth / 2 + 2, chartArea.top - nightSeparationFromChart);

          // Misma altura/grosor que la noche, con un pequeño hueco entre carriles
          const holidayLineWidth = nightLineWidth;
          const separationBetweenLanes = 6; // separación visual entre bordes

          const minY = holidayLineWidth / 2 + 2;
          const yTarget = yNight - (holidayLineWidth + separationBetweenLanes);
          const y = Math.max(minY, yTarget);

          // Referencias comunes para alinear todos los elementos del carril
          const laneLeft = chartArea.left;
          const laneRight = chartArea.right;

          ctx.setLineDash([]);
          ctx.globalAlpha = 1;
          ctx.lineWidth = holidayLineWidth;

          const visibleSegments: VisibleLaneSegment[] = [];

          // Línea base del carril (siempre visible aunque no haya tramos en ventana)
          {
            const baseLaneColor = toRgba(bsSecondary, 0.18);

            ctx.save();
            ctx.strokeStyle = baseLaneColor;
            ctx.beginPath();
            ctx.moveTo(laneLeft, y);
            ctx.lineTo(laneRight, y);
            ctx.stroke();
            ctx.restore();
          }

          for (const p of periods) {
            if (drawnSegments >= maxSegments) break;

            const ranges = this.getHolidayRangesAroundDate(p, now);
            for (const range of ranges) {
              if (drawnSegments >= maxSegments) break;

              const overlapStart = new Date(Math.max(range.start.getTime(), windowStart.getTime()));
              const overlapEnd = new Date(Math.min(range.end.getTime(), windowEnd.getTime()));
              if (overlapEnd.getTime() <= overlapStart.getTime()) continue;

              const xStart = currentWeekMinute + (overlapStart.getTime() - now.getTime()) / 60_000;
              const xEnd = currentWeekMinute + (overlapEnd.getTime() - now.getTime()) / 60_000;

              const pxStart = xScale.getPixelForValue(xStart);
              const pxEnd = xScale.getPixelForValue(xEnd);
              if (!Number.isFinite(pxStart) || !Number.isFinite(pxEnd)) continue;

              const segmentStart = Math.max(minX, xStart);
              const segmentEnd = Math.min(maxX, xEnd);
              if (segmentEnd <= segmentStart) continue;

              const baseColor = colorForPeriod(range.periodIndex);
              ctx.strokeStyle = tintToRgba(baseColor, 0.25, 0.95);
              ctx.beginPath();
              ctx.moveTo(pxStart, y);
              ctx.lineTo(pxEnd, y);
              ctx.stroke();

              visibleSegments.push({
                startMinute: segmentStart,
                endMinute: segmentEnd,
                periodIndex: range.periodIndex,
              });

              drawnSegments++;
            }
          }

          // Texto por tramos: sin periodo activo / periodo N, según corresponda en la ventana visible.
          {
            const normalizedSegments = [...visibleSegments]
              .sort((a, b) => a.startMinute - b.startMinute)
              .reduce((acc: VisibleLaneSegment[], segment) => {
                const last = acc[acc.length - 1];
                if (last && last.periodIndex === segment.periodIndex && segment.startMinute <= last.endMinute) {
                  last.endMinute = Math.max(last.endMinute, segment.endMinute);
                  return acc;
                }

                acc.push({ ...segment });
                return acc;
              }, []);

            const labeledSegments: VisibleLaneSegment[] = [];
            let cursor = minX;

            for (const segment of normalizedSegments) {
              const startMinute = Math.max(minX, segment.startMinute);
              const endMinute = Math.min(maxX, segment.endMinute);
              if (endMinute <= startMinute) continue;

              if (startMinute > cursor) {
                labeledSegments.push({
                  startMinute: cursor,
                  endMinute: startMinute,
                  periodIndex: 0,
                });
              }

              labeledSegments.push({
                startMinute,
                endMinute,
                periodIndex: segment.periodIndex,
              });
              cursor = Math.max(cursor, endMinute);
            }

            if (cursor < maxX) {
              labeledSegments.push({
                startMinute: cursor,
                endMinute: maxX,
                periodIndex: 0,
              });
            }

            ctx.save();
            ctx.font = '600 11px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            for (const segment of labeledSegments) {
              const pxStart = xScale.getPixelForValue(segment.startMinute);
              const pxEnd = xScale.getPixelForValue(segment.endMinute);
              if (!Number.isFinite(pxStart) || !Number.isFinite(pxEnd)) continue;

              const segmentLeft = Math.max(laneLeft, Math.min(pxStart, pxEnd));
              const segmentRight = Math.min(laneRight, Math.max(pxStart, pxEnd));
              const segmentWidth = segmentRight - segmentLeft;

              let label = '';
              if (segment.periodIndex > 0) {
                const fullLabel = `${this.t('period')} ${segment.periodIndex}`;
                const shortLabel = `P${segment.periodIndex}`;

                const fullWidth = ctx.measureText(fullLabel).width;
                const shortWidth = ctx.measureText(shortLabel).width;

                if (fullWidth + 16 <= segmentWidth) {
                  label = fullLabel;
                } else if (shortWidth + 10 <= segmentWidth) {
                  label = shortLabel;
                }
              } else {
                const neutralLabel = this.t('dlNoActivePeriod');
                const neutralWidth = ctx.measureText(neutralLabel).width;
                if (segmentWidth >= 72 && neutralWidth + 16 <= segmentWidth) {
                  label = neutralLabel;
                }
              }

              if (!label) continue;

              ctx.fillStyle = segment.periodIndex > 0 ? '#fff' : (bsSecondary || '#6c757d');
              ctx.fillText(label, segmentLeft + (segmentWidth / 2), y);
            }

            ctx.restore();
          }

          ctx.restore();
        }
      }]
    });

    if (output === 1) this.chartOut1 = chart;
    else this.chartOut2 = chart;

    if (this.chartOut1 && this.chartOut2) {
      this.chartOut1.update('none');
      this.chartOut2.update('none');
    }

    // Redibujar overlay cada vez que se (re)crea un chart
    window.setTimeout(() => this.renderSunLinesOverlay(), 0);



    this.nowLineTimerId = window.setInterval(() => {
      const r = this.getWindowRangeAroundNow();

      const updateRange = (c: Chart | null) => {
        if (!c) return;
        const xScale = (c.options.scales as any)?.x;
        if (xScale) {
          xScale.min = r.min;
          xScale.max = r.max;
        }
        c.update('none');
      };

      updateRange(this.chartOut1);
      updateRange(this.chartOut2);

      // Overlay debe seguir al rango/resize
      this.renderSunLinesOverlay();
    }, 30_000);


  }

  resetCounter(counter): void {

    if (window.confirm(this.translate.instant('channelsResetCounterConfirm'))) {

    const body = { };
    if (counter === 1) {

      body['c1counter'] = 0;
    }else {
      body['c2counter'] = 0;
    }

    console.log('body ', body);

      this._device
        .setModuleCfg(this.serial, body, 'channel')
        .subscribe((data) => {
          if (counter === 1) {
            this.channelInfo.stat.c1counter = 0;
          } else if (counter === 2) {
            this.channelInfo.stat.c2counter = 0;
          }
        });

  }}

  openYearlySunTimes(): void {
    const modalRef = this._modal.open(ModalAncSuntimesYearlyComponent, {
      centered: true,
      scrollable: true,
      size: 'xl',
    });
    modalRef.componentInstance.serial = this.serial;
  }

}
